function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5858 3.41421C17.3668 2.63316 17.3668 1.36683 16.5858 0.585786C15.8047 -0.195262 14.5384 -0.195262 13.7574 0.585786L8.5 5.84315L3.41421 0.757359C2.63316 -0.0236892 1.36683 -0.0236892 0.585786 0.757359C-0.195262 1.53841 -0.195262 2.80474 0.585786 3.58579L5.67157 8.67157L0.585787 13.7574C-0.195262 14.5384 -0.195262 15.8047 0.585787 16.5858C1.36684 17.3668 2.63316 17.3668 3.41421 16.5858L8.5 11.5L13.7574 16.7574C14.5384 17.5384 15.8047 17.5384 16.5858 16.7574C17.3668 15.9763 17.3668 14.71 16.5858 13.9289L11.3284 8.67157L16.5858 3.41421Z",
  fill: "#FF6B00"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.b791ebfb.svg";
export { ForwardRef as ReactComponent };